export default __webpack_public_path__ + "static/itaex-amarelo-1ef75c5949b437bb41916075e56cfd1d.png";